var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import styled from "styled-components";
import { propStyling, tombac } from "tombac";
export var TrialBadge = function (props) { return (React.createElement(Container, __assign({}, props), "Free trial")); };
var Container = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  all: initial;\n\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  cursor: inherit;\n  display: flex;\n  height: ", ";\n  padding: 0.1em ", " 0;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ", "\n\n  ", "\n"], ["\n  all: initial;\n\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  cursor: inherit;\n  display: flex;\n  height: ", ";\n  padding: 0.1em ", " 0;\n  text-transform: uppercase;\n  white-space: nowrap;\n\n  ", "\n\n  ", "\n"])), tombac.color("alert", 200), tombac.unit(5), tombac.unit(20), tombac.space(0.5), tombac.altText({
    color: tombac.color("alert", 500),
    fontSize: 10,
    fontWeight: 600,
}), propStyling);
var templateObject_1;
//# sourceMappingURL=TrialBadge.js.map